import './bootstrap';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import notificationPlugin from './plugins/notificationPlugin';
import dialogPlugin from './plugins/dialogPlugin';

// Import Bootstrap CSS and JS
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/custom.css';
import '../css/dashboard-premium.css';
import '../css/daily-expense-premium.css';
import '../css/activity-liquidity.css';
import '../css/porteo-ui.css';
import '@popperjs/core';
import 'bootstrap';
import { createPinia } from 'pinia';
import Antd, { message } from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import ProjectSelect from './components/common/ProjectSelect.vue';
import ActivityCombobox from './components/ActivityCombobox.vue';
import { branding } from './utils/branding';

// Ensure Ant Design messages and notifications appear below navbar (height: 65px)
message.config({
  top: '85px',
  duration: 4,
  maxCount: 3,
});

const app = createApp(App);
// Sélecteur de projet harmonisé (recherche + filtre « en cours » global)
app.component('ProjectSelect', ProjectSelect);
app.component('ActivityCombobox', ActivityCombobox);
// Identité de l'entreprise (nom du logiciel, nom de l'entreprise, logo) : $branding dans tous les gabarits
app.config.globalProperties.$branding = branding;

// Directive « clic en dehors » : utilisée par les sélecteurs personnalisés
// (planning global, réconciliations). Enregistrée globalement pour éviter
// « Failed to resolve directive: click-outside » sur les pages qui ne la
// déclarent pas localement.
app.directive('click-outside', {
  mounted(el, binding) {
    el.__clickOutside__ = (event) => {
      if (el !== event.target && !el.contains(event.target)) binding.value(event);
    };
    document.addEventListener('click', el.__clickOutside__);
  },
  unmounted(el) {
    document.removeEventListener('click', el.__clickOutside__);
    delete el.__clickOutside__;
  }
});
app.use(Antd);
app.use(createPinia());
app.use(router);
app.use(notificationPlugin);
app.use(dialogPlugin);
app.mount('#app');
